import { createSlice } from "@reduxjs/toolkit";

const creditHoldSlice = createSlice({
  name: "creditHold",
  initialState: {
    isOnHold: false,
  },
  reducers: {
    setCreditHold: (state, action) => {
      state.isOnHold = action.payload;
    },
  },
});

export const { setCreditHold } = creditHoldSlice.actions;
export default creditHoldSlice.reducer;
